import { createBrowserRouter, Navigate } from 'react-router-dom';
import { ProtectedRoute } from './ProtectedRoute';
import { AppLayout } from '../components/layout/AppLayout';
import LoginPage from '../pages/LoginPage';
import DashboardPage from '../pages/DashboardPage';
import TopicsPage from '../pages/TopicsPage';
import TopicDetailPage from '../pages/TopicDetailPage';
import QuizBuilderPage from '../pages/QuizBuilderPage';
import QuizPublishPage from '../pages/QuizPublishPage';
import QuizPlayerPage from '../pages/QuizPlayerPage';
import UsersPage from '../pages/UsersPage';
import NotFoundPage from '../pages/NotFoundPage';

export const router = createBrowserRouter([
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/q/:slug',
    element: <QuizPlayerPage />,
  },
  {
    path: '/',
    element: (
      <ProtectedRoute>
        <AppLayout />
      </ProtectedRoute>
    ),
    children: [
      { index: true, element: <Navigate to="/dashboard" replace /> },
      { path: 'dashboard', element: <DashboardPage /> },
      { path: 'topics', element: <TopicsPage /> },
      { path: 'topics/:id', element: <TopicDetailPage /> },
      { path: 'topics/:topicId/quizzes/new', element: <QuizBuilderPage /> },
      { path: 'quizzes/:id/edit', element: <QuizBuilderPage /> },
      { path: 'quizzes/:id/publish', element: <QuizPublishPage /> },
      {
        path: 'users',
        element: (
          <ProtectedRoute requireAdmin>
            <UsersPage />
          </ProtectedRoute>
        ),
      },
    ],
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
]);
